import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Advertiser, AffiliateNetworkAdvertisers } from '_models/affiliate-network-advertisers-data';
import { AdvertiserDetails } from '_models/advertiser-details';

@Injectable({ providedIn: 'root' })
export class LessPennyService {
  private apiBaseUrl = "https://localhost:96/api/";  //base URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  //   constructor(
  //     private http: HttpClient,
  //     private messageService: MessageService) { }
  constructor(private http: HttpClient) { }

  public getAffiliateNetworksAdvertisers(): Observable<AffiliateNetworkAdvertisers> {
    const endpoint = 'AffiliateNetworks/Advertisers';
    return this.http.get<AffiliateNetworkAdvertisers>(this.apiBaseUrl + endpoint)
      .pipe(
        catchError(this.handleError<any>('getAffiliateNetworksAdvertisers', []))
      );
  }

  //console.log(data);
  //return data;
  //return null;
  // var data = this.http.get<any>(this.lesspennyApiUrl);
  // console.log(data);
  // return data;

  // this.http.get<any>(this.lesspennyApiUrl)
  // .subscribe(
  //     (response) => {                           //next() callback
  //       console.log('response received')
  //       //this.repos = response; 
  //       console.log(response);
  //     },
  //     (error) => {                              //error() callback
  //       console.error('Request failed with error')
  //       console.log(error);
  //       //this.errorMessage = error;
  //       //this.loading = false;
  //     },
  //     () => {                                   //complete() callback
  //       console.error('Request completed')      //This is actually not needed 
  //       //this.loading = false; 
  //     })


  // .subscribe({
  //     next: data => {
  //         console.log(data);
  //         return data;
  //     },
  //     error: error => {                    
  //         console.error('There was an error!', error);
  //         console.log(error);
  //         return null;
  //     }
  // })
  // console.log('Returning NULL...');
  // return null;

  public getAdvertiserDetails(storeName: string): Observable<AdvertiserDetails> {
    const endpoint = 'api/AdvertiserDetails/' + storeName;
    return this.http.get<AdvertiserDetails>(this.apiBaseUrl + endpoint)
      .pipe(
        catchError(this.handleError<any>('getAdvertiserDetails' + storeName, []))
      );
  }

  public updateAffiliateNetworksAdvertisers(advertiser: Advertiser): Observable<any> {
    //debugger;
    const endpoint = 'AdvertiserDetails/' + advertiser.AdvertiserId;
    return this.http.put<AffiliateNetworkAdvertisers>(this.apiBaseUrl + endpoint, advertiser)
      .pipe(
        catchError(this.handleError<any>('getAffiliateNetworksAdvertisers', []))
      );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  //   /** Log a HeroService message with the MessageService */
  //   private log(message: string) {
  //     console.log(message);
  //     //this.messageService.add(`HeroService: ${message}`);
  //   }

}
  /** GET heroes from the server */
//   getHeroes(): Observable<Hero[]> {
//     return this.http.get<Hero[]>(this.heroesUrl)
//       .pipe(
//         tap(_ => this.log('fetched heroes')),
//         catchError(this.handleError<Hero[]>('getHeroes', []))
//       );
//   }

/** GET hero by id. Return `undefined` when id not found */
//   getHeroNo404<Data>(id: number): Observable<Hero> {
//     const url = `${this.heroesUrl}/?id=${id}`;
//     return this.http.get<Hero[]>(url)
//       .pipe(
//         map(heroes => heroes[0]), // returns a {0|1} element array
//         tap(h => {
//           const outcome = h ? `fetched` : `did not find`;
//           this.log(`${outcome} hero id=${id}`);
//         }),
//         catchError(this.handleError<Hero>(`getHero id=${id}`))
//       );
//   }

//   /** GET hero by id. Will 404 if id not found */
//   getHero(id: number): Observable<Hero> {
//     const url = `${this.heroesUrl}/${id}`;
//     return this.http.get<Hero>(url).pipe(
//       tap(_ => this.log(`fetched hero id=${id}`)),
//       catchError(this.handleError<Hero>(`getHero id=${id}`))
//     );
//   }

//   /* GET heroes whose name contains search term */
//   searchHeroes(term: string): Observable<Hero[]> {
//     if (!term.trim()) {
//       // if not search term, return empty hero array.
//       return of([]);
//     }
//     return this.http.get<Hero[]>(`${this.heroesUrl}/?name=${term}`).pipe(
//       tap(x => x.length ?
//          this.log(`found heroes matching "${term}"`) :
//          this.log(`no heroes matching "${term}"`)),
//       catchError(this.handleError<Hero[]>('searchHeroes', []))
//     );
//   }

//   //////// Save methods //////////

//   /** POST: add a new hero to the server */
//   addHero(hero: Hero): Observable<Hero> {
//     return this.http.post<Hero>(this.heroesUrl, hero, this.httpOptions).pipe(
//       tap((newHero: Hero) => this.log(`added hero w/ id=${newHero.id}`)),
//       catchError(this.handleError<Hero>('addHero'))
//     );
//   }

//   /** DELETE: delete the hero from the server */
//   deleteHero(id: number): Observable<Hero> {
//     const url = `${this.heroesUrl}/${id}`;

//     return this.http.delete<Hero>(url, this.httpOptions).pipe(
//       tap(_ => this.log(`deleted hero id=${id}`)),
//       catchError(this.handleError<Hero>('deleteHero'))
//     );
//   }

//   /** PUT: update the hero on the server */
//   updateHero(hero: Hero): Observable<any> {
//     return this.http.put(this.heroesUrl, hero, this.httpOptions).pipe(
//       tap(_ => this.log(`updated hero id=${hero.id}`)),
//       catchError(this.handleError<any>('updateHero'))
//     );
//   }

//   }



/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/